import { defaultRequestDateMode } from '../../../../constants/requests.constants';
import { filterConstants } from './constants';
import  moment  from 'moment';

const defaultDateRange = [moment().subtract(3, 'month').add(1,'days'), moment()];

export const defaultFilterValue = {
	dateRange: defaultDateRange, 	
	alertDateRange: null,
	selectedDateRange: undefined,
	dateRangeField: defaultRequestDateMode,
	valueDistrict: undefined,
	valueCompany: [],
	valueMethodCreatingRequest: [],
  valuePriorityRequest: [],
	valueWorker: [],
	valueExecuter: [],
  valueCreator: [],
	valuePaymentState: [],
	valueStatus: ['1','2'],
	valueSubservice: undefined,
	valueService: undefined,
	valueAddrStreet: undefined,
	valueAddrBuilding: undefined,
	valueAddrPorch: undefined,
	valueAddrFloor: undefined,
	valueAddrTypeFlat: undefined,
	valueAddrFlat: undefined,
	valueFlatByPorchFloor: undefined,
	valueStageFlat: undefined,
	valueStageCurrentFlat: undefined,
	valueAcceptanceStatusesFlat: undefined,
	valueCheckedStage: false,
	valuePhone: undefined,
	valueClientName: undefined,
	valueRating: undefined,
	valueWarrantyOrg: [],
	warranty: false,
	notWarranty: false,
	possWarranty: false,
	retry: false,
	chargeable: false,
	isOrder: false,
	expiredOnly: false,
	// userCreatedOnly: false,
	immediate: false,
	internal: false,
	badWork: false,
	waiting: false,
	attachmentFilter: undefined,
}

const defaultState = {
	saving: false,
	saved: false,
	saveFail: false,
	deleting: false,
	deleted: false,
	deleteFail: false,
	readingList: false,
	readListFail: false,
	savedList: [],
	selected: undefined,
	dataFetching: false,
	filterCompany: [],
	filterDistrict: [],
	filterWorker: [],
	filterStage: [],
	filterAcceptanceStatuses: [],
	filterExecuter: [],
  filterCreator: [],
	filterStatus: [],
	listSubservice: [],
	listService: [],
	listAddrBuilding: [],
	listAddrFlat: [],
	favorites: false,
	presetFilter: undefined,
	customFilter: undefined,
	relatedToExpired: true,
	isRelatedToExpiredLoading: false,
	filterChanged: false,
	...defaultFilterValue,
}

const withSingleCompany = (state) => {
	if (state.filterCompany?.length !== 1) return state;

	const [company] = state.filterCompany;
	const current = state.valueCompany;

	if (
		Array.isArray(current) &&
		current.length === 1 &&
		String(current[0]) === String(company.id)
	) {
		return state;
	}

	return { ...state, valueCompany: [company.id] };
};

const baseReducer = (state = defaultState, action = {}) => {
	switch (action.type) {
		case filterConstants.SAVE_FILTER+'_PENDING': {
			return {
				...state,
				saving:true,
				saved:false,
				saveFail:false,
			}
		}
		case filterConstants.SAVE_FILTER+'_FULFILLED': {
			return {
				...state,
				saving:false,
				saved:true,
				saveFail:false,
			}
		}
		case filterConstants.SAVE_FILTER+'_REJECTED': {
			return {
				...state,
				saving:false,
				saved:false,
				saveFail:true,
			}
		}
		case filterConstants.CLEAR_SAVE_FILTER_ERROR: {
			return {
				...state,
				saveFail:false,
			}
		}
		case filterConstants.SET_FILTER_CHANGED: {
			return {
				...state,
			  filterChanged: action.payload,
			}
		}
		case filterConstants.GET_SAVED_FILTERS_LIST+'_PENDING': {
			return {
				...state,
				readingList:true,
				readListFail:false,
			}
		}
		case filterConstants.GET_SAVED_FILTERS_LIST+'_FULFILLED': {
			return {
				...state,
				readingList:false,
				readListFail:false,
        savedList: action.payload?.data?.filters || [],
        relatedToExpired:
          action.payload?.data?.isExpiredToFiltersDepend ?? true,
			}
		}
		case filterConstants.GET_SAVED_FILTERS_LIST+'_REJECTED': {
			return {
				...state,
				readingList:false,
				readListFail:true,				
			}
		}
		case filterConstants.DELETE_FILTER+'_PENDING': {
			return {
				...state,
				deleting: true,
				deleted: false,
				deleteFail: false,
			}
		}
		case filterConstants.DELETE_FILTER+'_FULFILLED': {
			return {
				...state,
				deleting: false,
				deleted: true,
				deleteFail: false,
			}
		}
		case filterConstants.DELETE_FILTER+'_REJECTED': {
			return {
				...state,
				deleting: false,
				deleted: false,
				deleteFail: true,
			}

		}
		case filterConstants.SELECT_SAVED_FILTER: {
			const { filterData, filter } = action.payload;

			if (filter.dateRange) {
				filter.dateRange = filter.dateRange.map((dateStr) => moment(dateStr));
			}

				if(!!filter.alertDateRange) {
					filter.alertDateRange = filter.alertDateRange.map((dateStr) => moment(dateStr));
				}
			

			return {
				...state,
				selected: filterData,
				presetFilter: filterData.name,
				customFilter: undefined,
				...defaultFilterValue,
				...filter,
				valueCheckedStage: filter.valueStageCurrentFlat?.length || filter.valueStageFlat?.length || filter.valueAcceptanceStatusesFlat?.length
          ? true
          : state.valueCheckedStage,
			}
		}
		case filterConstants.SELECT_DATE_RANGE: {	
			return {
				...state,
				selectedDateRange: action.payload,
				dateRange: action.payload && action.payload.range || defaultDateRange, 
			}
		}
		case filterConstants.SELECT_ALERT_DATE_RANGE: {	
			return {
				...state,
				alertDateRange: action.payload,
			}
		}
		case filterConstants.RESET_FILTER: {
			return {
				...state,
				...defaultFilterValue,
				favorites: false,
				selected: undefined,
				presetFilter: undefined,
				customFilter: undefined,
				saveFail:false,
				relatedToExpired: true,
				isRelatedToExpiredLoading: false,
			}
		}
		case filterConstants.BACK_FILTER: {
			return {
				...state,
				...defaultFilterValue,
				...state.customFilter,				
				presetFilter: undefined,
				customFilter: undefined,
				selected: undefined,
			}
		}
		case filterConstants.APPLY_ADDRESS_FILTER: {
			const {
				dateRange, 	
				selectedDateRange,
				dateRangeField,
				valueDistrict,
				valueCompany,
				valueMethodCreatingRequest,
        valuePriorityRequest,
				valueWorker,
				valueExecuter,
        valueCreator,
				valueStatus,
				valueSubservice,
				valueService,
				valueAddrStreet,
				valueAddrBuilding,
				valueAddrFlat,
				valuePhone,
				valueRating,
				valueWarrantyOrg,
				warranty,
				notWarranty,
				possWarranty,
				retry,
				chargeable,
				isOrder,
				expiredOnly,
				// userCreatedOnly,
				immediate,
				internal,
				badWork,
				waiting,
				attachmentFilter,
				favorites,
				valueClientName,
			}  = state;
			return {
				...state,
				...defaultFilterValue,
				customFilter: {
					dateRange, 	
					selectedDateRange,
					dateRangeField,
					valueDistrict,
					valueCompany,
					valueMethodCreatingRequest,
          valuePriorityRequest,
					valueWorker,
					valueExecuter,
          valueCreator,
					valueStatus,
					valueSubservice,
					valueService,
					valueAddrStreet,
					valueAddrBuilding,
					valueAddrFlat,
					valuePhone,
					valueRating,
					valueWarrantyOrg,
					warranty,
					notWarranty,
					possWarranty,
					retry,
					chargeable,
					isOrder,
					expiredOnly,
					// userCreatedOnly,
					immediate,
					internal,
					badWork,
					waiting,
					attachmentFilter,
					favorites,
					valueClientName,
				}, 
				dateRange: [
					moment('1900-01-01'), 
				  moment()], 	
				valueStatus: [],
				valueAddrStreet: action.payload.valueAddrStreet,
				valueAddrBuilding:action.payload.valueAddrBuilding,
				valueAddrFlat: action.payload.valueAddrFlat,	
				presetFilter: action.payload.filterName,
				selected: undefined,
				favorites: false
			}
		}
		case filterConstants.SWITCH_FAVORITES: {
			return {
				...state,
				presetFilter: undefined,
				customFilter: undefined,
				selected: undefined,
				favorites: action.payload
			}
		}

		case filterConstants.FETCH_SUBSERVICE + '_FULFILLED': {
			return {
				...state,
				listSubservice: action.payload.data.data || action.payload.data
			}
		}
		case filterConstants.SET_ADDR_BUILDING_VALUE: {
			return {
				...state,
				presetFilter: undefined,
				customFilter: undefined,
				selected: undefined,
				valueAddrBuilding: action.payload
			}
		}
    case filterConstants.SET_ADDR_PORCH_VALUE: {
			return { ...state, valueAddrPorch: action.payload }
    }
		case filterConstants.SET_ADDR_FLOOR_VALUE: {
			return { ...state, valueAddrFloor: action.payload }
		}
		case filterConstants.SET_ADDR_TYPE_FLAT_VALUE: {
			return { ...state, valueAddrTypeFlat: action.payload }
		}
		case filterConstants.SET_ADDR_FLAT_VALUE: {
			return {
				...state,
				presetFilter: undefined,
				customFilter: undefined,
				selected: undefined,
				valueAddrFlat: action.payload,
			}
		}
		case filterConstants.SET_FLAT_VALUE_BY_PORCH_FLOOR: {
			return {
				...state,
				valueFlatByPorchFloor: action.payload,
			}
		}
		case filterConstants.RESET_ADDR_VALUES: {
			return {
				...state,
				valueAddrPorch: undefined,
				valueAddrFloor: undefined,
				valueAddrTypeFlat: undefined,
				valueAddrFlat: undefined,
				valueFlatByPorchFloor: undefined,
			}
		}
		case filterConstants.SET_STAGE_CURRENT_FLAT_VALUE: {
			return {
				...state,
				valueStageCurrentFlat: action.payload
			}
		}
		case filterConstants.SET_STAGE_FLAT_VALUE: {
			return {
				...state,
				valueStageFlat: action.payload
			}
		}
				case filterConstants.SET_ACCEPTANCE_STATUSES_FLAT_VALUE: {
			return {
				...state,
				valueAcceptanceStatusesFlat: action.payload
			}
		}
		case filterConstants.SET_VALUE_CKECKED_STAGE: {
			return {
				...state,
				valueStageFlat: undefined,
				valueStageCurrentFlat: undefined,
				valueAcceptanceStatusesFlat: undefined,
				valueCheckedStage: action.payload,
			}
		}
		case filterConstants.SET_PHONE_VALUE: {
			return {
				...state,
				selected: undefined,
				presetFilter: undefined,
				valuePhone: action.payload
			}
		}
		case filterConstants.SET_CLIENT_NAME_VALUE: {
			return {
				...state,
				selected: undefined,
				presetFilter: undefined,
				valueClientName: action.payload
			}
		}
		case filterConstants.SET_RATING_VALUE: {
			return {
				...state,
				selected: undefined,
				presetFilter: undefined,
				valueRating: action.payload
			}
		}
		case filterConstants.APPLY_ADDR_STREET: {
			return {
				...state,
				presetFilter: undefined,
				customFilter: undefined,
				selected: undefined,
				valueAddrStreet: action.payload
			}
		}
		case filterConstants.FETCH_ADDR_BUILDING + '_FULFILLED': {
			return {
				...state,
				listAddrBuilding: action.payload.data.data || action.payload.data
			}
		}
		case filterConstants.FETCH_ADDR_FLAT + '_FULFILLED': {
			return {
				...state,
				listAddrFlat: action.payload.data.data || action.payload.data
			}
		}
		case filterConstants.SET_SUBSERVICE_VALUE: {
			return {
				...state,
				presetFilter: undefined,
				selected: undefined,
				valueSubservice: action.payload
			}
		}
		case filterConstants.SET_DATE_RANGE: {
			return {
				...state,
				selected: undefined,
				presetFilter: undefined,
				dateRange: action.payload
			}
		}
		case filterConstants.SET_DATE_RANGE_FIELD: {
			return {
				...state,
				presetFilter: undefined,
				selected: undefined,
				dateRangeField: action.payload
			}
		}
    case filterConstants.SET_RELATED_TO_EXPIRED + '_FULFILLED': {
      return {
        ...state,
        relatedToExpired: action.payload,
				isRelatedToExpiredLoading: false
      };
    }
    case filterConstants.SET_RELATED_TO_EXPIRED + '_PENDING': {
      return {
        ...state,
				isRelatedToExpiredLoading: true,
      };
    }
    case filterConstants.SET_RELATED_TO_EXPIRED + '_REJECTED': {
      return {
        ...state,
				isRelatedToExpiredLoading: false,
      };
    }
		case filterConstants.APPLY_WARRANTY: {
			return {
				...state,
				warranty: action.payload,
				presetFilter: undefined,
				selected: undefined,
				notWarranty: false
			}
		}
		case filterConstants.APPLY_ATTACHMENT_FILTER: {
			return {
				...state,
				presetFilter: undefined,
				selected: undefined,
				attachmentFilter: action.payload,
			}
		}
		case filterConstants.APPLY_NOT_WARRANTY: {
			return {
				...state,
				warranty: false,
				presetFilter: undefined,
				selected: undefined,
				notWarranty: action.payload
			}
		}
		case filterConstants.APPLY_POSS_WARRANTY: {
			return {
				...state,
				presetFilter: undefined,
				selected: undefined,
				possWarranty: action.payload
			}
		}
		case filterConstants.APPLY_RETRY: {
			return {
				...state,
				presetFilter: undefined,
				selected: undefined,
				retry: action.payload
			}
		}
		case filterConstants.APPLY_CHARGEABLE: {
			return {
				...state,
				presetFilter: undefined,
				selected: undefined,
				chargeable: action.payload
			}
		}
		case filterConstants.APPLY_IS_ORDER: {
			return {
				...state,
				presetFilter: undefined,
				selected: undefined,
				isOrder: action.payload,
			}
		}
  	// case filterConstants.APPLY_USER_CREATED: {
		// 	return {
		// 		...state,
		// 		presetFilter: undefined,
		// 		selected: undefined,
		// 		userCreatedOnly: action.payload
		// 	}
		// }
  	case filterConstants.APPLY_EXPIRED_ONLY: {
			return {
				...state,
				presetFilter: undefined,
				selected: undefined,
				expiredOnly: action.payload
			}
		}
		case filterConstants.APPLY_IMMEDIATE: {
			return {
				...state,
				presetFilter: undefined,
				selected: undefined,
				immediate: action.payload
			}
		}
		case filterConstants.APPLY_INTERNAL: {
			return {
				...state,
				presetFilter: undefined,
				selected: undefined,
				internal: action.payload
			}
		}
		case filterConstants.APPLY_BADWORK: {
			return {
				...state,
				presetFilter: undefined,
				selected: undefined,
				badWork: action.payload
			}
		}
		case filterConstants.APPLY_WAITING: {
			return {
				...state,
				presetFilter: undefined,
				selected: undefined,
				waiting: action.payload
			}
		}
		case filterConstants.APPLY_COMPANY: {
			return {
				...state,
				presetFilter: undefined,
				selected: undefined,
				valueCompany: action.payload
			}
		}
		case filterConstants.APPLY_DISTRICT: {
			return {
				...state,
				presetFilter: undefined,
				selected: undefined,
				valueDistrict: action.payload
			}
		}
		case filterConstants.APPLY_WARRANTY_ORG: {
			const warranty = state.warranty ? true : action.payload && action.payload.length>0
			const notWarranty = state.notWarranty && warranty ? false : state.notWarranty
			return {
				...state,
				presetFilter: undefined,
				selected: undefined,
				warranty,
				notWarranty, 
				valueWarrantyOrg: action.payload
			}
		}
		case filterConstants.SET_FILTER_COMPANY + '_FULFILLED': {
			return {
				...state,
				filterCompany: action.payload.data.data || action.payload.data
			}
		}
		case filterConstants.SET_FILTER_DISTRICT + '_FULFILLED': {
			return {
				...state,
				filterDistrict: action.payload.data.data || action.payload.data
			}
		}
		case filterConstants.APPLY_METHOD_CREATING_REQUEST: {
			return {
				...state,
				selected: undefined,
				presetFilter: undefined,
				valueMethodCreatingRequest: action.payload
			}
		}
    case filterConstants.APPLY_PRIORITY_REQUEST: {
      return {
        ...state,
        selected: undefined,
        presetFilter: undefined,
        valuePriorityRequest: action.payload,
      };
    }
		case filterConstants.APPLY_WORKER: {
			return {
				...state,
				selected: undefined,
				presetFilter: undefined,
				valueWorker: action.payload
			}
		}
		case filterConstants.APPLY_EXECUTER: {
			return {
				...state,
				selected: undefined,
				presetFilter: undefined,
				valueExecuter: action.payload
			}
		}
		case filterConstants.APPLY_CREATOR: {
			return {
				...state,
				selected: undefined,
				presetFilter: undefined,
				valueCreator: action.payload
			}
		}
		case filterConstants.APPLY_PAYMENT_STATE: {
			return {
				...state,
				selected: undefined,
				presetFilter: undefined,
				valuePaymentState: action.payload
			}
		}
		case filterConstants.APPLY_SERVICE: {
			return {
				...state,
				selected: undefined,
				presetFilter: undefined,
				valueService: action.payload
			}
		}
		case filterConstants.SET_FILTER_SERVICE + '_FULFILLED': {
			return {
				...state,
				listService: action.payload.data.data || action.payload.data
			}
		}
		case filterConstants.SET_FILTER_WORKER + '_FULFILLED': {
			return {
				...state,
				filterWorker: action.payload.data.data || action.payload.data
			}
		}
		case filterConstants.SET_FILTER_STAGE + '_FULFILLED': {
			return {
				...state,
				filterStage:	action.payload.data?.stagesAddressLifeCycle || []
			}
		}
		case filterConstants.SET_FILTER_ACCEPTANCE_STATUSES + '_FULFILLED': {
			return {
				...state,
				filterAcceptanceStatuses:	action.payload.data?.acceptanceStatuses || []
			}
		}
		case filterConstants.SET_FILTER_EXECUTER + '_FULFILLED': {
			return {
				...state,
				filterExecuter: action.payload.data.data || action.payload.data
			}
		}
		case filterConstants.SET_FILTER_CREATOR + '_FULFILLED': {
			return {
				...state,
				filterCreator: action.payload.data.data || action.payload.data
			}
		}
		case filterConstants.APPLY_STATUS: {
			return {
				...state,
				selected: undefined,
				presetFilter: undefined,
				valueStatus: action.payload
			}
		}
		case filterConstants.SET_FILTER_STATUS + '_FULFILLED': {
			return {
				...state,
				filterStatus: action.payload.data.data || action.payload.data
			}
		}
		case filterConstants.RETRIEVE_LAST_STATE: {
			return {
				...state,
				...action.payload
			}
		}
		case filterConstants.SET_REQUEST_EXECUTE_TIME + '_REJECTED': 
		case filterConstants.SET_REQUEST_EXECUTER + '_REJECTED': 
		case filterConstants.SET_REQUEST_MASTER + '_REJECTED': 
		case filterConstants.SET_REQUEST_SERVICE + '_REJECTED': 
		case filterConstants.SET_REQUEST_RATING +'_REJECTED': 
		case filterConstants.SET_REQUEST_STATUS +'_REJECTED': 		
		case filterConstants.SET_FILTER_COMPANY +'_REJECTED': 
		case filterConstants.SET_FILTER_WORKER +'_REJECTED': 
		case filterConstants.SET_FILTER_STAGE +'_REJECTED': 
		case filterConstants.SET_FILTER_ACCEPTANCE_STATUSES +'_REJECTED':
		case filterConstants.SET_FILTER_EXECUTER +'_REJECTED': 
		case filterConstants.SET_FILTER_CREATOR +'_REJECTED': 
		case filterConstants.SET_FILTER_SERVICE +'_REJECTED': 
		case filterConstants.SET_FILTER_STATUS +'_REJECTED': 
		case filterConstants.SET_REQUEST_ADDRESS + '_REJECTED':
		case filterConstants.SET_FILTER_DISTRICT +'_REJECTED': 
		case filterConstants.FETCH_ADDR_BUILDING +'_REJECTED': 
		case filterConstants.FETCH_ADDR_FLAT +'_REJECTED': 
		case filterConstants.FETCH_SUBSERVICE +'_REJECTED': {			
			return {
				...state,
				dataFetching: false,
			}
		}
		default:
			return state;
	}
}

export default (state, action) => withSingleCompany(baseReducer(state, action));
